<template>
  <v-container fluid>
    <v-row class="fill-height" align-content="center" justify="center" v-if="!showCalendar" dense>
      <v-col class="text-subtitle-1 text-center" cols="12">
        <span class="title black--text">
          Cargando Solicitudes en el Calendario
        </span>
      </v-col>
      <v-col cols="6">
        <v-progress-linear color="blue darken-1 accent-3" indeterminate height="6" rounded></v-progress-linear>
      </v-col>
    </v-row>

    <v-row class="fill-height" dense>
      <v-col cols="12">
        <v-sheet height="64">
          <v-toolbar flat>
            <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday"> HOY </v-btn>
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small> mdi-chevron-left </v-icon>
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small> mdi-chevron-right </v-icon>
            </v-btn>

            <v-toolbar-title v-if="$refs.calendar"> {{ $refs.calendar.title }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right> mdi-menu-down </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Día</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Semana</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Mes</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = '4day'">
                  <v-list-item-title>4 Días</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>
        <v-sheet height="700">
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="events"
            :event-color="getEventColor"
            :type="type"
            locale="mx"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="updateRange">
          </v-calendar>
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x>

            <v-card color="grey lighten-4" min-width="650px" flat v-if="selectedEvent.item">
              <v-toolbar :color="selectedEvent.item.last_movement.estatus.color" dark>
                <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <ViewDetails :object="selectedEvent.item" type="Movements"/>
              </v-card-text>
              <v-card-actions>
                <v-layout justify-end>
                  <v-btn text color="secondary" @click="selectedOpen = false"> Cerrar </v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>

          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ViewDetails from '@/components/ViewDetails'

export default {
  data: () => ({
    focus: '',
    type: 'month',
    typeToLabel: {
      month: 'Mes',
      week: 'Semana',
      day: 'Dia',
      '4day': '4 Dias'
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    showCalendar: false,
    lastStart: null,
    lastEnd: null
  }),
  components: {
    ViewDetails
  },
  mounted () {
    this.$refs.calendar.checkChange()
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjectsService']),
    getDataUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.GETObjectsService({ url: router, params: `${this.lastStart}/${this.lastEnd}`, replace: '{start}/{end}' })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['CLEAR_OBJECTS']),

    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor (event) {
      return event.color
    },
    setToday () {
      this.focus = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        setTimeout(() => {
          this.selectedOpen = true
        }, 10)
      }
      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }
      nativeEvent.stopPropagation()
    },
    updateRange ({ start, end }) {
      this.showCalendar = false
      this.lastStart = start.date
      this.lastEnd = end.date
      this.getDataUrl('ma.calendarios-list')
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objects'])
  },
  watch: {
    get_urls (val) {
      this.getDataUrl('ma.calendarios-list')
    },
    get_objects (vals) {
      if (vals) {
        this.events = []
        this.events = vals.map(i => {
          let start = null
          let end = null
          if (i.descripcion.programar && i.descripcion.programar === 'Programado') {
            start = new Date(i.descripcion.fInicial)
            end = new Date(i.descripcion.fFinal)
          } else {
            start = new Date(i.created_at)
            end = new Date((i.last_movement) ? i.last_movement.created_at : i.created_at)
          }
          const nombre = (i.descripcion.solicitante_id) ? i.descripcion.solicitante.NombreCompleto : i.descripcion.solicitante
          return {
            name: `${nombre} - ${i.tipo_servicio.nombre}`,
            start: start,
            end: end,
            color: (i.last_movement) ? i.last_movement.estatus.color : 'white',
            timed: false,
            item: i
          }
        })
        this.showCalendar = true
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }
}
</script>

<style>

</style>
